import { Navigate, resolvePath, useLocation } from 'react-router-dom';

import useAccountPermission from '../hooks/useAccountPermission';

import type { AccountRolePermissions } from '@rewardopl/types';

type PermissionGateProps = {
  children: React.ReactElement;
  permission: keyof AccountRolePermissions;
};

export default function PermissionGate({ children, permission }: PermissionGateProps) {
  const location = useLocation();
  const isAuthorized = useAccountPermission(permission);

  if (!isAuthorized) {
    return <Navigate to={resolvePath('..', location.pathname)} replace />;
  }

  return children;
}
